import React from "react";
import classNames from "classnames";

import AlertIcon from "components/Icons/alert.svg";
import InfoIcon from "components/Icons/info.svg";
import CloseIcon from "components/Icons/x.svg";

type Props = {
  message: string | JSX.Element;
  onDismiss: () => void;
  icon?: string;
  iconClasses?: string;
  className?: string;
};

const Toast = ({
  message,
  icon = "info",
  iconClasses,
  className,
  onDismiss,
  ...others
}: Props): JSX.Element => (
  <div
    data-testid="toast"
    role="alert"
    className={classNames(
      "relative toast-content flex items-center py-lg elevation-low rounded w-full",
      className
    )}
    {...others}
  >
    {icon === "info" && (
      <InfoIcon
        height="30"
        width="30"
        aria-hidden="true"
        className={classNames("flex-shrink-0 mx-lg", iconClasses)}
      />
    )}
    {icon === "alert" && (
      <AlertIcon
        height="30"
        width="30"
        aria-hidden="true"
        className={classNames("flex-shrink-0 mx-lg", iconClasses)}
      />
    )}
    {message}
    <div className="absolute right-5">
      <button onClick={onDismiss} aria-label="close" className="cursor-pointer">
        <CloseIcon width="25" height="25" />
      </button>
    </div>
    <style jsx={true}>{`
      .toast-content {
        padding-right: 50px;
      }
    `}</style>
  </div>
);

export default Toast;
